//////////////////////////////////////////////////////////20260421//////////////////////////////////////////////////
// import React, { useEffect } from 'react'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { FaFileCircleCheck, FaFileCirclePlus, FaFilePen, FaRotate, FaMarker } from 'react-icons/fa6'
import { FaEdit } from 'react-icons/fa'
import { GiTeamUpgrade } from 'react-icons/gi'
import { STEP, nextStep, prevStep, getStepOrder } from '../Project/projectStepManager'

function Projectuserbox({
    edit,
    pg,
    allpg,
    updates,
    setEdit,
    userId,
    admin,
    upgrade,
    downgrade,
    openModalHandlers,
    dedit,
    setDedit,
    rightViewNum,
    setRightViewNum,
    onEstimateSubmitFromControlBox,
    contract,
    pendingNextLabel,
    onOpenPaymentInput,
}) {
    const writableStatuses = [STEP.ESTIMATE_WRITE, STEP.CONTRACT_WRITE, STEP.DEV1, STEP.DEV2, STEP.FINAL_REPORT]
    const canWrite = writableStatuses.includes(pg.adminstatus)

    const statusLabel = pg.adminstatus
    const [viewSeqIndex, setViewSeqIndex] = useState(0)

    function getCurrentStepOrder() {
        if (!pg || !pg.adminstatus) return 0
        return getStepOrder(pg.adminstatus)
    }

    function getViewSequence() {
        var order = getCurrentStepOrder()

        var sequence = [0]

        if (order >= getStepOrder(STEP.ESTIMATE_WRITE)) {
            sequence.push(1)
        }

        // 사양서는 계약서에 통합했으므로 2 제외

        if (order >= getStepOrder(STEP.CONTRACT_WRITE)) {
            sequence.push(3)
        }

        // 선금 납부: 선금 단계 이후에는 계속 과거 단계로 남김
        if (order >= getStepOrder(STEP.DEPOSIT)) {
            sequence.push(41)
        }

        if (order >= getStepOrder(STEP.DEV1)) {
            sequence.push(5)
        }

        // 중도금 납부: 중도금 단계 이후에는 계속 과거 단계로 남김
        if (order >= getStepOrder(STEP.MIDDLE)) {
            sequence.push(42)
        }

        if (order >= getStepOrder(STEP.DEV2)) {
            sequence.push(6)
        }

        if (order >= getStepOrder(STEP.FINAL_REPORT)) {
            sequence.push(7)
        }

        // 잔금 납부: 잔금 단계 이후에는 계속 과거 단계로 남김
        if (order >= getStepOrder(STEP.FINAL_PAY)) {
            sequence.push(43)
        }

        if (order >= getStepOrder(STEP.DONE)) {
            sequence.push(8)
        }

        return sequence
    }
    function getLastIndexOfView(sequence, viewNum) {
        var result = 0

        for (var i = 0; i < sequence.length; i++) {
            if (sequence[i] === viewNum) {
                result = i
            }
        }

        return result
    }

    function isWriteView(nextNum) {
        return (
            (nextNum === 1 && pg && pg.adminstatus === STEP.ESTIMATE_WRITE) ||
            (nextNum === 3 && pg && pg.adminstatus === STEP.CONTRACT_WRITE) ||
            (nextNum === 5 && pg && pg.adminstatus === STEP.DEV1) ||
            (nextNum === 6 && pg && pg.adminstatus === STEP.DEV2) ||
            (nextNum === 7 && pg && pg.adminstatus === STEP.FINAL_REPORT)
        )
    }

    function getMaxRightViewNum() {
        if (statusLabel === STEP.TEMP) return 0
        if (statusLabel === STEP.REGISTER) return 0

        if (statusLabel === STEP.ESTIMATE_WRITE) return 1
        if (statusLabel === STEP.ESTIMATE_RECEIVE) return 1
        if (statusLabel === STEP.ESTIMATE_APPROVE) return 2

        if (statusLabel === STEP.CONTRACT_WRITE) return 3
        if (statusLabel === STEP.CONTRACT_RECEIVE) return 3
        if (statusLabel === STEP.CONTRACT_SIGN) return 4

        if (statusLabel === STEP.DEPOSIT) return 41

        if (statusLabel === STEP.DEV1) return 5
        if (statusLabel === STEP.DEV1_RECEIVE) return 5
        if (statusLabel === STEP.DEV1_APPROVE) return 5

        if (statusLabel === STEP.MIDDLE) return 42

        if (statusLabel === STEP.DEV2) return 6
        if (statusLabel === STEP.DEV2_RECEIVE) return 6
        if (statusLabel === STEP.DEV2_APPROVE) return 6

        if (statusLabel === STEP.FINAL_REPORT) return 7
        if (statusLabel === STEP.FINAL_REPORT_RECEIVE) return 7
        if (statusLabel === STEP.FINAL_REPORT_APPROVE) return 7

        if (statusLabel === STEP.FINAL_PAY) return 43
        // if (statusLabel === STEP.DONE) return 7
        if (statusLabel === STEP.DONE) return 8

        return 0
    }

    function resetRightViewToCurrentStep() {
        var maxView = getMaxRightViewNum()

        if (typeof setRightViewNum === 'function') {
            setRightViewNum(maxView)
        }

        var sequence = getViewSequence()
        setViewSeqIndex(getLastIndexOfView(sequence, maxView))

        if (maxView === 1 && pg && pg.adminstatus === STEP.ESTIMATE_WRITE) {
            setDedit(true)
        } else if (maxView === 3 && pg && pg.adminstatus === STEP.CONTRACT_WRITE) {
            setDedit(true)
        } else if (maxView === 5 && pg && pg.adminstatus === STEP.DEV1) {
            setDedit(true)
        } else if (maxView === 6 && pg && pg.adminstatus === STEP.DEV2) {
            setDedit(true)
        } else if (maxView === 7 && pg && pg.adminstatus === STEP.FINAL_REPORT) {
            setDedit(true)
        } else {
            setDedit(false)
        }
    }

    useEffect(
        function () {
            resetRightViewToCurrentStep()
        },
        [pg && pg.adminstatus],
    )

    function getRightViewLabel() {
        if (rightViewNum === 0) return '프로젝트 등록'
        if (rightViewNum === 1) return '견적서 작성'
        if (rightViewNum === 2) return '계약서'
        if (rightViewNum === 3) return '계약서'

        if (rightViewNum === 4) return '납부'
        if (rightViewNum === 41) return '선금 납부'
        if (rightViewNum === 42) return '중도금 납부'
        if (rightViewNum === 43) return '잔금 납부'

        if (rightViewNum === 5) return '1단계 개발 보고서'
        if (rightViewNum === 6) return '2단계 개발 보고서'
        if (rightViewNum === 7) return '3단계 개발 보고서'
        if (rightViewNum === 8) return '프로젝트 완료'

        return '프로젝트 등록'
    }

    function getPrevStepLabel() {
        var prev = prevStep(statusLabel)
        if (!prev || prev === statusLabel) return ''
        return prev
    }

    function getNextStepLabel() {
        if (statusLabel === STEP.ESTIMATE_WRITE) return STEP.ESTIMATE_RECEIVE
        if (statusLabel === STEP.ESTIMATE_RECEIVE) return STEP.CONTRACT_WRITE
        if (statusLabel === STEP.CONTRACT_WRITE) return STEP.CONTRACT_RECEIVE
        if (statusLabel === STEP.CONTRACT_RECEIVE) return STEP.DEPOSIT
        if (statusLabel === STEP.CONTRACT_SIGN) return STEP.DEPOSIT
        if (statusLabel === STEP.DEPOSIT) return STEP.DEV1

        if (statusLabel === STEP.DEV1) return STEP.DEV1_RECEIVE
        if (statusLabel === STEP.DEV1_RECEIVE) return STEP.MIDDLE
        if (statusLabel === STEP.DEV1_APPROVE) return STEP.MIDDLE

        if (statusLabel === STEP.MIDDLE) return STEP.DEV2
        if (statusLabel === STEP.DEV2) return STEP.DEV2_RECEIVE
        if (statusLabel === STEP.DEV2_RECEIVE) return STEP.FINAL_REPORT
        if (statusLabel === STEP.DEV2_APPROVE) return STEP.FINAL_REPORT

        if (statusLabel === STEP.FINAL_REPORT) return STEP.FINAL_REPORT_RECEIVE
        if (statusLabel === STEP.FINAL_REPORT_RECEIVE) return STEP.FINAL_PAY
        if (statusLabel === STEP.FINAL_REPORT_APPROVE) return STEP.FINAL_PAY

        if (statusLabel === STEP.FINAL_PAY) return STEP.DONE

        var next = nextStep(statusLabel)
        if (!next || next === statusLabel) return ''
        return next
    }

    function getDisplayNextLabel() {
        if (statusLabel === STEP.ESTIMATE_WRITE) return '견적서 제출'
        if (statusLabel === STEP.ESTIMATE_RECEIVE) return '계약서 작성'
        if (statusLabel === STEP.CONTRACT_WRITE) return '계약서 제출'
        if (statusLabel === STEP.CONTRACT_RECEIVE) return '선금 납부'
        if (statusLabel === STEP.CONTRACT_SIGN) return '선금 납부'

        if (statusLabel === STEP.DEPOSIT) return '1단계 개발'

        if (statusLabel === STEP.DEV1) return '1단계 개발 보고서 제출'
        if (statusLabel === STEP.DEV1_RECEIVE) return '중도금 납부'
        if (statusLabel === STEP.DEV1_APPROVE) return '중도금 납부'

        if (statusLabel === STEP.MIDDLE) return '2단계 개발'

        if (statusLabel === STEP.DEV2) return '2단계 개발 보고서 제출'
        if (statusLabel === STEP.DEV2_RECEIVE) return '3단계 개발'
        if (statusLabel === STEP.DEV2_APPROVE) return '3단계 개발'

        if (statusLabel === STEP.FINAL_REPORT) return '3단계 개발 보고서 제출'
        if (statusLabel === STEP.FINAL_REPORT_RECEIVE) return '잔금 납부'
        if (statusLabel === STEP.FINAL_REPORT_APPROVE) return '잔금 납부'

        if (statusLabel === STEP.FINAL_PAY) return '프로젝트 완료'

        return nextStepLabel
    }

    function canStepUp() {
        if (!nextStepLabel) return false

        if (statusLabel === STEP.ESTIMATE_RECEIVE) {
            return !!(contract && contract.b3f)
        }

        if (statusLabel === STEP.CONTRACT_RECEIVE) {
            return !!(contract && contract.c2f)
        }

        if (statusLabel === STEP.CONTRACT_SIGN) {
            return !!(contract && contract.c2f)
        }

        if (statusLabel === STEP.DEPOSIT) {
            return !!(contract && contract.d2f)
        }

        if (statusLabel === STEP.DEV1) {
            return true
        }

        if (statusLabel === STEP.DEV1_RECEIVE) {
            return false
        }

        if (statusLabel === STEP.DEV1_APPROVE) {
            return true
        }

        if (statusLabel === STEP.MIDDLE) {
            return !!(contract && contract.d4f)
        }

        if (statusLabel === STEP.DEV2) {
            return true
        }

        if (statusLabel === STEP.DEV2_RECEIVE) {
            return false
        }

        if (statusLabel === STEP.DEV2_APPROVE) {
            return true
        }

        if (statusLabel === STEP.FINAL_REPORT) {
            return true
        }

        if (statusLabel === STEP.FINAL_REPORT_RECEIVE) {
            return false
        }

        if (statusLabel === STEP.FINAL_REPORT_APPROVE) {
            return true
        }

        if (statusLabel === STEP.FINAL_PAY) {
            return !!(contract && contract.e1)
        }

        return true
    }

    const prevStepLabel = getPrevStepLabel()
    const nextStepLabel = getNextStepLabel()
    const displayNextLabel = getDisplayNextLabel()
    const maxRightViewNum = getMaxRightViewNum()
    const canStepUpButton = canStepUp()

    const isFinalReportBlocked = statusLabel === STEP.FINAL_REPORT && !(contract && contract.r2f)

    const isStepUpGray = !canStepUpButton || isFinalReportBlocked

    const canStepUpButtonStyle = {
        opacity: isStepUpGray ? 0.8 : 1,
        cursor: 'pointer',
        backgroundColor: isStepUpGray ? '#b1b1b1' : '',
        color: isStepUpGray ? '#fff' : '',
        border: isStepUpGray ? '1px solid #b1b1b1' : '',
    }

    const onClickEdit = (value) => {
        if (dedit) {
            Swal.fire({
                title: '단계정보 작성중입니다',
                icon: 'warning',
            })
        } else if (value === true) {
            Swal.fire({
                title: '프로젝트를 수정하시겠습니까?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: '아니요',
                confirmButtonText: '네',
            }).then((result) => {
                if (result.isConfirmed) {
                    setEdit(value)
                }
            })
        } else {
            setEdit(value)
        }
    }

    const onClickDedit = () => {
        if (!canWrite) {
            return
        }

        if (edit) {
            Swal.fire({
                title: '프로젝트정보 수정중입니다',
                icon: 'warning',
            })
        } else {
            setDedit(!dedit)
        }
    }

    const onClickViewPrev = () => {
        if (typeof setRightViewNum !== 'function') {
            return
        }

        var sequence = getViewSequence()
        var currentIndex = getLastIndexOfView(sequence, rightViewNum)
        var nextIndex = currentIndex <= 0 ? 0 : currentIndex - 1
        var nextNum = sequence[nextIndex]

        setViewSeqIndex(nextIndex)
        setRightViewNum(nextNum)
        setDedit(isWriteView(nextNum))
    }

    const onClickViewNext = () => {
        if (typeof setRightViewNum !== 'function') {
            return
        }

        var sequence = getViewSequence()
        var currentIndex = getLastIndexOfView(sequence, rightViewNum)
        var nextIndex = currentIndex >= sequence.length - 1 ? sequence.length - 1 : currentIndex + 1
        var nextNum = sequence[nextIndex]

        setViewSeqIndex(nextIndex)
        setRightViewNum(nextNum)
        setDedit(isWriteView(nextNum))
    }

    const viewSequence = getViewSequence()
    const currentViewSeqIndex = getLastIndexOfView(viewSequence, rightViewNum)
    const isFirstView = currentViewSeqIndex <= 0
    const isLastView = currentViewSeqIndex >= viewSequence.length - 1

    return (
        <>
            <div className="p20tb">
                <h1 className="mb0">클라이언트 정보</h1>
            </div>
            <div className="flex userinfoBox">
                <div className="flex j a borderBottom borderTop p20tb">
                    <h2 className="mr10">
                        <span className="mr5">ID :</span>
                        {pg.userId !== 'null' ? pg.userId : <span className="f12">미등록 아이디</span>}
                    </h2>
                    <button onClick={() => openModalHandlers()} className="navibtn_hover p10 f12 w60px">
                        더보기
                    </button>
                </div>

                <ul className="p20tb">
                    <li className="flex a j mb5">
                        <span className="flex a">
                            <span className="midcircle mr5">
                                <FaFilePen />
                            </span>{' '}
                            등록 프로젝트{' '}
                        </span>
                        <span>
                            {
                                allpg
                                    .filter((value) => value.userId === pg.userId)
                                    .filter((item) => item.a2 !== null && item.c2 === null).length
                            }
                            개
                        </span>
                    </li>
                    <li className="flex j mb5">
                        <span className="flex a">
                            <span className="midcircle mr5">
                                <FaFileCircleCheck />
                            </span>
                            진행 프로젝트{' '}
                        </span>
                        <span>
                            {
                                allpg
                                    .filter((value) => value.userId === pg.userId)
                                    .filter((item) => item.c2 !== null && item.e1 === null).length
                            }
                            개
                        </span>
                    </li>
                    <li className="flex j mb5">
                        <span className="flex a">
                            <span className="midcircle mr5">
                                <FaFileCirclePlus />
                            </span>{' '}
                            완료 프로젝트{' '}
                        </span>
                        <span>
                            {
                                allpg.filter((value) => value.userId === pg.userId).filter((item) => item.e1 !== null)
                                    .length
                            }
                            개
                        </span>
                    </li>
                </ul>

                <ul className="p20tb borderTop  ">
                    <li className="flex a j mb5">
                        <span className="flex a">
                            <span className="midcircle mr5">
                                <FaRotate />
                            </span>
                            {'진행 단계: '} {statusLabel === STEP.FINAL_REPORT ? '3단계 개발' : statusLabel}{' '}
                        </span>

                        <button
                            onClick={() => window.location.reload()}
                            className="navibtn_hover p10 f12"
                            style={{
                                width: '30px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            ⟳
                        </button>
                    </li>

                    {userId === pg.userId || admin ? (
                        <li className="mb5">
                            {admin ? (
                                <div className="flex j a">
                                    <span className="flex a">
                                        <span className="midcircle mr5">
                                            <GiTeamUpgrade />
                                        </span>{' '}
                                        단계 이동{' '}
                                    </span>
                                    <div>
                                        <button
                                            onClick={onClickViewPrev}
                                            className="navibtn_hover p10 w60px mr5 f12"
                                            style={{
                                                opacity: isFirstView ? 0.5 : 1,
                                                cursor: isFirstView ? 'not-allowed' : 'pointer',
                                            }}
                                            disabled={isFirstView}
                                        >
                                            ←
                                        </button>
                                        <span> </span>
                                        <button
                                            onClick={onClickViewNext}
                                            className="navibtn_hover p10 w60px f12"
                                            style={{
                                                opacity: isLastView ? 0.5 : 1,
                                                cursor: isLastView ? 'not-allowed' : 'pointer',
                                            }}
                                            disabled={isLastView}
                                        >
                                            →
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </li>
                    ) : (
                        ''
                    )}

                    {getRightViewLabel() === '프로젝트 등록' && (
                        <li className="flex a j mb5">
                            <span className="flex a">
                                <span className="midcircle mr5">
                                    <FaMarker />
                                </span>{' '}
                                {getRightViewLabel()}
                            </span>

                            {/* {rightViewNum === 0 ? ( */}
                            {rightViewNum === 0 && statusLabel !== STEP.DONE ? (
                                !edit ? (
                                    <button onClick={() => onClickEdit(true)} className="navibtn_hover p10 w60px f12">
                                        수정
                                    </button>
                                ) : (
                                    <div className="flex">
                                        <button
                                            onClick={() => onClickEdit(false)}
                                            className="navibtn_hover p10 w60px mr10 f12"
                                        >
                                            이전
                                        </button>
                                        <button onClick={() => updates()} className="navibtn_hover p10 w60px f12">
                                            저장
                                        </button>
                                    </div>
                                )
                            ) : !dedit ? (
                                <button
                                    onClick={() => onClickDedit()}
                                    className="navibtn_hover p10 w60px f12"
                                    disabled={!canWrite}
                                    style={{
                                        opacity: canWrite ? 1 : 0.5,
                                        cursor: canWrite ? 'pointer' : 'not-allowed',
                                    }}
                                >
                                    작성
                                </button>
                            ) : (
                                <button onClick={() => onClickDedit()} className="navibtn_hover p10 w60px f12">
                                    뒤로
                                </button>
                            )}
                        </li>
                    )}

                    <li className="flex mb5" style={{ alignItems: 'flex-start' }}>
                        <span className="flex a">
                            <span className="midcircle mr5">
                                <FaEdit />
                            </span>
                            단계 변경
                        </span>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '5px',
                                marginLeft: '10px',
                            }}
                        >
                            <button
                                onClick={() => {
                                    if (!canStepUpButton) {
                                        if (statusLabel === STEP.ESTIMATE_RECEIVE) {
                                            Swal.fire(
                                                '수요기업의 견적서 승인 후 계약서 작성으로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.CONTRACT_RECEIVE) {
                                            Swal.fire(
                                                '수요기업의 계약서 서명 완료 후 선금 납부 단계로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.CONTRACT_SIGN) {
                                            Swal.fire(
                                                '수요기업의 계약서 서명 완료 후 선금 납부 단계로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.DEPOSIT) {
                                            Swal.fire(
                                                '선금 입금 확인 완료 후 1단계 개발로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.DEV1_RECEIVE) {
                                            Swal.fire(
                                                '수요기업의 1단계 보고서 승인 후 중도금 납부를 진행할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.DEV2_RECEIVE) {
                                            Swal.fire(
                                                '수요기업의 2단계 보고서 승인 후 3단계 개발로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.FINAL_REPORT_RECEIVE) {
                                            Swal.fire(
                                                '수요기업의 3단계 보고서 승인 후 잔금 납부를 진행할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.MIDDLE) {
                                            if (!(contract && contract.r1f)) {
                                                Swal.fire(
                                                    '1단계 개발 보고서 승인 후 2단계 개발로 이동할 수 있습니다.',
                                                    '확인 버튼을 눌러 주세요',
                                                    'warning',
                                                )
                                                return
                                            }

                                            if (!(contract && contract.d4f)) {
                                                Swal.fire(
                                                    '중도금 확인 완료 후 2단계 개발로 이동할 수 있습니다.',
                                                    '확인 버튼을 눌러 주세요',
                                                    'warning',
                                                )
                                                return
                                            }
                                        }

                                        if (statusLabel === STEP.DEV2 && contract && contract.develop2) {
                                            Swal.fire(
                                                '2단계 개발 보고서 승인 후 3단계 개발로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.FINAL_REPORT && contract && contract.develop3) {
                                            Swal.fire(
                                                '3단계 개발 보고서 제출 후 잔금 납부 탭으로 이동할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.FINAL_REPORT) {
                                            Swal.fire(
                                                '2단계 개발 보고서 승인 후 3단계 개발을 진행할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        if (statusLabel === STEP.FINAL_PAY) {
                                            if (!(contract && contract.r3f)) {
                                                Swal.fire(
                                                    '3단계 개발 보고서 승인 후 프로젝트 완료로 이동할 수 있습니다.',
                                                    '확인 버튼을 눌러 주세요',
                                                    'warning',
                                                )
                                                return
                                            }

                                            if (!(contract && contract.e1)) {
                                                Swal.fire(
                                                    '잔금 확인 완료 후 프로젝트 완료로 이동할 수 있습니다.',
                                                    '확인 버튼을 눌러 주세요',
                                                    'warning',
                                                )
                                                return
                                            }
                                        }

                                        Swal.fire(
                                            '이전 단계 완료 후 이동할 수 있습니다.',
                                            '확인 버튼을 눌러 주세요',
                                            'warning',
                                        )
                                        return
                                    }

                                    if (statusLabel === STEP.FINAL_REPORT && displayNextLabel === '3단계 개발') {
                                        if (!(contract && contract.r2f)) {
                                            Swal.fire(
                                                '2단계 개발 보고서 승인 후 3단계 개발 보고서를 작성할 수 있습니다.',
                                                '확인 버튼을 눌러 주세요',
                                                'warning',
                                            )
                                            return
                                        }

                                        setRightViewNum(7)
                                        setDedit(true)
                                        return
                                    }

                                    if (
                                        displayNextLabel === '견적서 제출' ||
                                        displayNextLabel === '계약서 제출' ||
                                        displayNextLabel === '1단계 개발 보고서 제출' ||
                                        displayNextLabel === '2단계 개발 보고서 제출' ||
                                        displayNextLabel === '3단계 개발 보고서 제출'
                                    ) {
                                        if (typeof onEstimateSubmitFromControlBox === 'function') {
                                            onEstimateSubmitFromControlBox()
                                        }
                                        return
                                    }

                                    upgrade()
                                }}
                                className="navibtn_hover p10 f12"
                                disabled={edit}
                                style={{
                                    width: '130px',
                                    minWidth: '110px',
                                    padding: '10px 5px',
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    lineHeight: '1.2',
                                    ...canStepUpButtonStyle,
                                    opacity: edit ? 0.5 : canStepUpButtonStyle.opacity,
                                    cursor: edit ? 'not-allowed' : canStepUpButtonStyle.cursor,
                                }}
                            >
                                {nextStepLabel ? (
                                    displayNextLabel === '1단계 개발 보고서 제출' ? (
                                        <>
                                            1단계 개발 보고서
                                            <br />
                                            제출 ▶
                                        </>
                                    ) : displayNextLabel === '2단계 개발 보고서 제출' ? (
                                        <>
                                            2단계 개발 보고서
                                            <br />
                                            제출 ▶
                                        </>
                                    ) : displayNextLabel === '3단계 개발 보고서 제출' ? (
                                        <>
                                            3단계 개발 보고서
                                            <br />
                                            제출 ▶
                                        </>
                                    ) : statusLabel === STEP.DEPOSIT && !(contract && contract.d2f) ? (
                                        <>1단계 개발 ▶</>
                                    ) : statusLabel === STEP.MIDDLE && !(contract && contract.d4f) ? (
                                        <>2단계 개발 ▶</>
                                    ) : statusLabel === STEP.FINAL_PAY && !(contract && contract.e1) ? (
                                        <>프로젝트 완료 ▶</>
                                    ) : (
                                        displayNextLabel + ' ▶'
                                    )
                                ) : (
                                    '없음 ▶'
                                )}
                            </button>

                            <button
                                onClick={() => downgrade()}
                                className="navibtn_hover p10 f12"
                                style={{
                                    width: '130px',
                                    minWidth: '110px',
                                    padding: '10px 5px',
                                    textAlign: 'center',
                                    opacity: edit || !prevStepLabel ? 0.5 : 1,
                                    cursor: edit || !prevStepLabel ? 'not-allowed' : 'pointer',
                                }}
                                disabled={edit || !prevStepLabel}
                            >
                                {prevStepLabel
                                    ? '◀ ' + (prevStepLabel === STEP.FINAL_REPORT ? '3단계 개발 보고서' : prevStepLabel)
                                    : '◀ 없음'}{' '}
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Projectuserbox
